/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Label_FailedInputs */

const vi_carrier_label_failed = /** @type {(inputs: Carrier_Label_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không lấy được liên kết in vận đơn`)
};

/**

* @param {Carrier_Label_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_label_failed = /** @type {((inputs?: Carrier_Label_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Label_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_label_failed(inputs)
});